module.exports = __webpack_public_path__ + "static/img/Retargeting-Selected.1756645.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Retargeting-Selected.png
// module id = 1763
// module chunks = 0